<h3 mat-dialog-title>
  <div>Visualizar OS</div>
</h3>

<mat-dialog-content class="pdf-content">
  <div *ngIf="!loading && !messageError && url" class="pdf-container">
    <iframe [src]="url" title="PDF de Orden de Servicio"></iframe>
  </div>

  <mat-spinner *ngIf="loading" [diameter]="100"></mat-spinner>
  <span *ngIf="loading" class="loader-text">Cargando documento...</span>

  <span class="error-text" *ngIf="!loading && messageError">
    {{ messageError }}
  </span>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-stroked-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
